'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Spinner", {
    enumerable: true,
    get: function() {
        return Spinner;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useSpinner = require("./useSpinner");
const _renderSpinner = require("./renderSpinner");
const _useSpinnerStylesstyles = require("./useSpinnerStyles.styles");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const Spinner = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useSpinner.useSpinner_unstable)(props, ref);
    (0, _useSpinnerStylesstyles.useSpinnerStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useSpinnerStyles_unstable')(state);
    return (0, _renderSpinner.renderSpinner_unstable)(state);
});
Spinner.displayName = 'Spinner';
